import React, { useState, useEffect } from "react";
import { Form, Input, Button, Card, message, Select } from "antd";
import axios from "axios";
import { API_BASE } from "../../config/api";
import { getAuthHeaders } from "../../utils/auth";

const { Option } = Select;

const CreateSubCategory = ({onSuccess}) => {
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [form] = Form.useForm();

  // Cargar categorías al inicio
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(`${API_BASE}/category`);
        setCategories(res.data);
      } catch (err) {
        message.error("Error cargando categorías");
      }
    };

    fetchCategories();
  }, []);

  const onFinish = async (values) => {
    try {
      setLoading(true);

      await axios.post(`${API_BASE}/subcategory`, {
        name: values.name,
        description: values.description,
        categoryId: values.categoryId,
      }, {
        headers: getAuthHeaders(),
      });

      message.success("Subcategoría creada correctamente");
      form.resetFields();
      onSuccess();

    } catch (err) {
      console.log(err);
      message.error("Error creando subcategoría");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card  style={{ maxWidth: 500, margin: "auto" }}>
      <Form layout="vertical" form={form} onFinish={onFinish}>

        {/* Categoría padre */}
        <Form.Item
          label="Categoría"
          name="categoryId"
          rules={[{ required: true, message: "Seleccione una categoría" }]}
        >
          <Select placeholder="Seleccione una categoría">
            {categories.map((cat) => (
              <Option key={cat.id} value={cat.id}>
                {cat.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        {/* Nombre */}
        <Form.Item
          label="Nombre de la Subcategoría"
          name="name"
          rules={[{ required: true, message: "Ingrese el nombre" }]}
        >
          <Input placeholder="Ej: Coloración" />
        </Form.Item>

        {/* Descripción */}
        <Form.Item
          label="Descripción"
          name="description"
          rules={[{ required: true, message: "Ingrese la descripción" }]}
        >
          <Input placeholder="Ej: Colores, tinturas..." />
        </Form.Item>

        {/* Botón */}
        <Button type="primary" htmlType="submit" block loading={loading}>
          Crear Subcategoría
        </Button>

      </Form>
    </Card>
  );
};

export default CreateSubCategory;
